import { render, staticRenderFns } from "./PaysOld.vue?vue&type=template&id=51904edc"
import script from "./PaysOld.vue?vue&type=script&lang=js"
export * from "./PaysOld.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports